
import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import Features from './components/Features';
import Contact from './components/Contact';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/924ba4d8-6ba6-40d3-9855-21a22ec5b434.png" 
              alt="DELKO d.o.o. Logo" 
              className="h-10 w-10 object-contain"
            />
            <span className={`text-xl font-semibold transition-colors ${scrolled ? 'text-gray-900' : 'text-white'}`}>
              DELKO d.o.o.
            </span>
          </div>
          <div className="flex items-center gap-8">
            <button 
              onClick={() => scrollToSection('home')}
              className={`text-sm font-medium transition-colors hover:opacity-80 whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700' : 'text-white'}`}
            >
              Home
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors hover:opacity-80 whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700' : 'text-white'}`}
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('products')}
              className={`text-sm font-medium transition-colors hover:opacity-80 whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700' : 'text-white'}`}
            >
              Products
            </button>
            <button 
              onClick={() => scrollToSection('features')}
              className={`text-sm font-medium transition-colors hover:opacity-80 whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700' : 'text-white'}`}
            >
              Features
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors hover:opacity-80 whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700' : 'text-white'}`}
            >
              Contact
            </button>
          </div>
        </div>
      </nav>

      {/* Sections */}
      <Hero />
      <About />
      <Products />
      <Features />
      <Contact />
    </div>
  );
}
